import {DxUserSession} from "../../../domain/user/dx-user-session";
import {DxSessionValidationStrategy} from "./dx-session-validation-strategy";
import {DxLogger} from "../../../../dx-core/services/dx-logger.service";
import {Injectable} from "@angular/core";

@Injectable()
export class DxBasicValidationStrategy implements DxSessionValidationStrategy {

  constructor(private _logger: DxLogger) {}

  public validateSession(session: DxUserSession): boolean {
    // Сессия считается не валидной если:
    // 1. Сессии нет :)
    return !!session;
  }
}
